import axios from 'axios';

const getAccessToken = () => sessionStorage.getItem('accessToken');

export const getHeaders = (isPatch = false, token) => {

  const accessToken = getAccessToken();
  return {
    accept: 'application/json',
    // 'Content-Type': isPatch ? 'application/json-patch+json' : 'application/json',
    'Authorization': token ? `Bearer ${token}` : `Bearer ${accessToken}` // Fixed typo here
  };
};

const isContentTypeJSON = (headers) =>
  headers.get('content-type')?.includes('application/json') ?? false;

const isContentTypePdf = (headers) =>
  headers.get('content-type')?.includes('application/pdf') ?? false;

export const createTransactionResultFrom = (response) => ({
  ok: response.ok,
  status: response.status,
  headers: response.headers,
});

export const genericGet = async ({ url }) => {
  try {
    const response = await axios.get(url, { headers: getHeaders(false) });

    const transactionResult = createTransactionResultFrom(response);

    if (response.status >= 200 && response.status <= 299) {
      transactionResult.data = response.data;
    } else if (response.status >= 400 && response.status <= 499) {
      const responseError = response.data;
      throw new Error(responseError ? responseError.error?.[0].reason : 'general error');
    }

    return transactionResult;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.error?.[0].reason || 'general error');
    }
    throw new Error(error.message);
  }
};

export const genericPost = async (url, body, token) => {
  const accessToken = getAccessToken();

  try {
    const response = await axios.post(url, body, {
      headers: {
        accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        'Authorization': token ? `Bearer ${token}` : `Bearer ${accessToken}`
      },
    });

    // Create transaction result from response
    const transactionResult = createTransactionResultFrom(response);

    // Assuming createTransactionResultFrom and isContentTypeJSON are utility functions you have
    const isJson = response.headers['content-type']?.includes('application/json');

    if (response.status >= 200 && response.status <= 299) {
      transactionResult.data = isJson ? response.data : undefined;
    }

    if (response.status >= 400 && response.status <= 499) {
      transactionResult.error = isJson ? response.data : undefined;
    }

    return transactionResult;
  } catch (error) {
    // Handle axios-specific error structure
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const isJson = error.response.headers['content-type']?.includes('application/json');
      const errorData = isJson ? error.response.data : undefined;

      return {
        error: errorData,
        status: error.response.status,
        // Optionally add more fields to the transactionResult based on your needs
      };
    } else if (error.request) {
      // The request was made but no response was received
      return {
        error: 'No response received',
        status: 0,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        error: error.message,
        status: 0,
      };
    }
  }
};


export const genericPut = async (url, body, token) => {
  try {
    const response = await axios.put(url, body, { headers: getHeaders(false, token) });
    const transactionResult = createTransactionResultFrom(response);

    // Check if the response status is within the success range
    if (response.status >= 200 && response.status <= 299) {
      transactionResult.data = response.data;
    } else if (response.status >= 400 && response.status <= 499) {
      // Handle client errors
      const responseError = response.data;
      throw new Error(responseError?.error?.[0]?.reason || 'Client error');
    } else if (response.status >= 500) {
      // Handle server errors
      throw new Error('Server error');
    }

    return transactionResult;
  } catch (error) {
    // Handle errors from Axios
    if (error.response) {
      throw new Error(error.response.data?.error?.[0]?.reason || 'Request error');
    }
    // Handle other errors
    throw new Error(error.message || 'Unknown error');
  }
};

export const genericDownloadPdf = async ({ url, fileName }) => {
  const accessToken = getAccessToken();

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`, // Ensure headers include the Authorization if required
      },
    });

    const transactionResult = createTransactionResultFrom(response);
    const isPDF = isContentTypePdf(response.headers);

    if (response.status >= 200 && response.status <= 299) {
      if (isPDF) {
        const blobResponse = await response.blob();
        const objectURL = URL.createObjectURL(blobResponse);
        const anchorEl = document.createElement('a');
        anchorEl.href = objectURL;
        anchorEl.download = `${fileName}.pdf`;
        anchorEl.click();
        URL.revokeObjectURL(objectURL);
      } else {
        throw new Error('Not a PDF');
      }
    }

    return transactionResult;
  } catch (error) {
    return { ok: false };
  }
};

export const genericPostFileUpload = async (url, body) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      body: body instanceof FormData ? body : JSON.stringify(body),
      headers: body instanceof FormData ? {} : getHeaders(false), // Adjust headers for FormData
    });

    const transactionResult = createTransactionResultFrom(response);
    const isJson = isContentTypeJSON(response.headers);

    if (response.status >= 200 && response.status <= 299) {
      transactionResult.data = isJson ? await response.json() : undefined;
    } else if (response.status >= 400 && response.status <= 499) {
      transactionResult.error = isJson ? await response.json() : undefined;
    }

    return transactionResult;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const printFunction = (elementId, uniqueIframeId, fileName) => {

  // const PASSWORD = "1234";
  // const userInput = prompt("Enter password to print:");
  // if (userInput !== PASSWORD) {
  //   alert("Incorrect password. Printing cancelled.");
  //   return;
  // }

  // const fileName = 'invoice';
  const SaveFile = fileName;
  document.title = SaveFile;
  // @@@@@@@@@@@@ 

  const content = document.getElementById(elementId);
  let pri;

  // Check if iframe with uniqueIframeId already exists
  if (document.getElementById(uniqueIframeId)) {
    pri = document.getElementById(uniqueIframeId).contentWindow;
  } else {
    // Create a new iframe if it doesn't exist
    const iframe = document.createElement('iframe');
    iframe.setAttribute('title', uniqueIframeId);
    iframe.setAttribute('id', uniqueIframeId);
    iframe.setAttribute('style', 'height: 0px; width: 0px; position: absolute;');
    document.body.appendChild(iframe);
    pri = iframe.contentWindow;
  }

  // Open the document, write the content, and trigger the print
  pri.document.open();

  // pri.document.write(content.innerHTML);
  pri.document.write(`
    <html>
      <head>
                  <title>Title</title>
        <style>
          @media print {
            body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              margin: 0 !important;
              padding: 0 !important;
              background-color: white !important;
              color: black !important;
              font-family: Arial, sans-serif;
            }
            .print-box {
              background-color: white !important;
              color: black !important;
              padding: 0 !important;
              margin: 0 !important;
              border-radius: 0 !important;
            }
          }
  
          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            background-color: white;
            color: black;
          }
  
          .print-box {
            background-color: white;
            color: black;
            padding: 0;
            margin: 0;
            border-radius: 0;
          }
        </style>
      </head>
      <body>
        <div class="print-box">
          ${content.innerHTML}
        </div>
      </body>
    </html>
  `);

  pri.document.close();
  pri.focus();
  pri.print();

};
export const convertNumberToWords = (amount) => {
  if (isNaN(amount)) return 'Invalid number';

  const ones = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
    'Seventeen', 'Eighteen', 'Nineteen',
  ];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const numToWords = (num) => {
    let word = '';
    if (num > 19) {
      word += tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + ones[num % 10] : '');
    } else {
      word += ones[num];
    }
    return word;
  };

  const getIndianNumberWords = (num) => {
    let result = '';
    const crore = Math.floor(num / 10000000);
    const lakh = Math.floor((num % 10000000) / 100000);
    const thousand = Math.floor((num % 100000) / 1000);
    const hundred = Math.floor((num % 1000) / 100);
    const rest = num % 100;

    if (crore) result += numToWords(crore) + ' Crore ';
    if (lakh) result += numToWords(lakh) + ' Lakh ';
    if (thousand) result += numToWords(thousand) + ' Thousand ';
    if (hundred) result += ones[hundred] + ' Hundred ';
    if (rest) result += (result !== '' ? '' : '') + numToWords(rest);

    return result.trim();
  };

  const [intPart, decimalPart] = amount.toString().split('.');
  const integer = parseInt(intPart, 10);
  const paise = parseInt(decimalPart || '0', 10);

  let result = getIndianNumberWords(integer);

  if (paise) {
    result += ` and ${getIndianNumberWords(paise)}`;
  }

  return result + ' Only';
};




// Function to render HTML content safely
export const renderHtmlContent = (htmlString) => {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
};

export const formatDateLong = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'long' });
  const year = date.getFullYear();
  return `${day} ${month} , ${year}`;
};


// src/utils/dateFormatter.js

export const companyDateFormat = (dateString, formatType = "1") => {
  if (!dateString) return '';
  const date = new Date(dateString);
  switch (formatType) {
    case "1":
      return date.toLocaleDateString("en-GB"); // dd/mm/yyyy
    case "2":
      return date.toLocaleDateString("en-US"); // mm/dd/yyyy
    case "3":
      return date.toISOString().slice(0, 10);  // yyyy-mm-dd
    case "4":
      return date.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" }); // 28 June 2025
    case "5":
      return date.toLocaleDateString("en-GB", { weekday: "long", day: "2-digit", month: "short", year: "numeric" }); // Saturday, 28 Jun 2025
    case "6":
      return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" }); // 28 Jun 25
    default:
      return date.toLocaleDateString();
  }
};
